function buchnersRewriteProductLinks(root = document) {
  const links = [];

  if (root instanceof HTMLAnchorElement) {
    links.push(root);
  }

  if (root.querySelectorAll) {
    links.push(...root.querySelectorAll('a[href*="/products/"]'));
  }

  links.forEach((link) => {
    const href = link.getAttribute('href');
    if (!href) return;

    try {
      const url = new URL(href, window.location.href);

      if (url.origin !== window.location.origin || !url.pathname.includes('/products/')) return;
      if (url.searchParams.get('view') === 'buchners') return;

      url.searchParams.set('view', 'buchners');
      link.setAttribute('href', `${url.pathname}${url.search}${url.hash}`);
    } catch (error) {
      // Ignore malformed or non-navigational href values.
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  buchnersRewriteProductLinks(document);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes') {
        buchnersRewriteProductLinks(mutation.target);
      }

      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          buchnersRewriteProductLinks(node);
        }
      });
    });
  });

  observer.observe(document.body, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['href'],
  });
});

document.addEventListener('cart:update', (event) => {
  const data = event?.detail?.data;

  if (data?.source !== 'product-form-component' || data?.didError) return;

  window.location.assign('/cart?view=buchners');
});
